import { createSlice } from "@reduxjs/toolkit";

interface UiState {
  onboardingOverlayHidden: boolean;
}

const initialState: UiState = {
  onboardingOverlayHidden: false,
};

const uiSlices = createSlice({
  name: "ui",
  initialState,
  reducers: {
    hideOnboardingOverlay(state) {
      state.onboardingOverlayHidden = true;
    },
    showOnboardingOverlay(state) {
      state.onboardingOverlayHidden = false;
    },
  },
});

export const { hideOnboardingOverlay, showOnboardingOverlay } = uiSlices.actions;

export default uiSlices;


